<template>
  <div class="back-top" v-show="showBackTop" @click="backToTop">
    <slot>
      <button class="back-top-btn"></button>
    </slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBackTop: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showBackTop = window.pageYOffset > 100;
    },
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.back-top {
  position: fixed;
  bottom: 80px;
  right: 17px;
  z-index: 999;
}

.back-top-btn {
  background-color: rgba(124, 174, 228, 0.8);
  color: #fff;
  border: 2px solid #fff;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.back-top-btn::before {
  content: "";
  display: inline-block;
  border-style: solid;
  border-width: 0.15em 0.15em 0 0;
  transform: rotate(-45deg);
  height: 0.8em;
  width: 0.8em;
  position: relative;
  top: 3px;
}
</style>
